import { PayloadAction, createAction } from "typesafe-actions";

export const setNewChatModalIsOpen: (isOpen: boolean) => PayloadAction<"modals/newChatModal", boolean> =
  createAction("modals/newChatModal")<boolean>();

export const setNewChatServiceModalIsOpen: (isOpen: boolean) => PayloadAction<"modals/newChatServiceModal", boolean> =
  createAction("modals/newChatServiceModal")<boolean>();

export const setChatFolderModalIsOpen: (isOpen: boolean) => PayloadAction<"modals/chatFolderModalIsOpen", boolean> =
  createAction("modals/chatFolderModalIsOpen")<boolean>();

export const setChatSelectFoldersModalIsOpen: (
  isOpen: boolean
) => PayloadAction<"modals/setChatSelectFoldersModalIsOpen", boolean> = createAction(
  "modals/setChatSelectFoldersModalIsOpen"
)<boolean>();

export const setChatSelectFolderSettingModalIsOpen: (
  isOpen: boolean
) => PayloadAction<"modals/setChatSelectFolderSettingModalIsOpen", boolean> = createAction(
  "modals/setChatSelectFolderSettingModalIsOpen"
)<boolean>();
